<template>
    <div id="ExpetPim">
        <Head />
        <div class="hotspot clear">
            <Nav ms="/ExpertPim" />
            <div class="H-right">
                <main>
                    <div class="title">
                        <div>
                            <i></i>
                            <h3>个人信息</h3>
                        </div>
                        <div class="btn" @click="dialogFormVisible = true">修改密码</div>
                        <el-dialog
                            width="30%"
                            title="修改密码"
                            style="text-align: center"
                            :visible.sync="dialogFormVisible"
                        >
                            <el-form :model="form">
                                <el-form-item label="原密码" :label-width="formLabelWidth">
                                    <el-input
                                        v-model="form.password"
                                        type="password"
                                        placeholder="请输入原密码"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="新密码" :label-width="formLabelWidth">
                                    <el-input
                                        v-model="form.password1"
                                        type="password"
                                        placeholder="请输入新密码密码"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="确认密码" :label-width="formLabelWidth">
                                    <el-input
                                        v-model="form.password2"
                                        type="password"
                                        placeholder="请输入新密码密码"
                                    ></el-input>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogFormVisible = false">取 消</el-button>
                                <el-button type="primary" @click="changpswd">确 定</el-button>
                            </div>
                        </el-dialog>
                    </div>
                    <div class="container">
                        <!-- <el-table :show-header="true" :data="tableData" style="width: 100%">
            <el-table-column prop="name" width="300" ></el-table-column>
            <el-table-column prop="phone" style="width:100%"></el-table-column>
            </el-table>-->
                        <div>
                            <b>
                                姓
                                <span></span> 名:
                            </b>
                            <p>{{ userinfo.Realname }}</p>
                        </div>
                        <div>
                            <b>出生年月:</b>
                            <p>{{ userinfo.birthdate }}</p>
                        </div>
                        <div>
                            <b>
                                学
                                <span></span> 历:
                            </b>
                            <p>{{ userinfo.education }}</p>
                        </div>
                        <div>
                            <b>
                                职
                                <span></span> 称:
                            </b>
                            <p>{{ userinfo.Position }}</p>
                        </div>
                        <div>
                            <b>工作单位:</b>
                            <p>{{ userinfo.workunit }}</p>
                        </div>
                        <div>
                            <b>
                                职
                                <span></span> 务:
                            </b>
                            <p>{{ userinfo.jobcontent }}</p>
                        </div>
                        <div>
                            <b>电子邮箱:</b>
                            <p>{{ userinfo.Email }}</p>
                        </div>
                        <div>
                            <b>手机号:</b>
                            <p>{{ userinfo.Phone }}</p>
                        </div>
                        <div>
                            <b>专业方向：</b>
                            <p>{{ userinfo.ParentClassName }} — {{ userinfo.ClassName }}</p>
                        </div>
                        <!-- <div>
              <b>所在专家组：</b>
              <p>{{userinfo.group}}</p>
            </div> -->
                        <div>
                            <b>专家简介:</b>
                            <p style="line-height:.4rem;margin-top:.2rem">{{ userinfo.introduction }}</p>
                        </div>

                        <!-- <div>
              <b>所在部门：</b>
              <p>{{userinfo.Department}}</p>
            </div>
            <div>
              <b>
                职
                <span></span>务:
              </b>
              <p>{{userinfo.Position}}</p>
            </div>
            <div>
              <b>企业信用代码：</b>
              <p>{{userinfo.Code}}</p>
            </div>
            <div>
              <b>电子邮箱：</b>
              <p>{{userinfo.Email}}</p>
            </div>
            <div class="last">
              <b>营业执照:</b>
              <img @click="imgshow = true" :src="userinfo.Image" alt />
            </div>-->
                    </div>
                </main>
            </div>
        </div>

        <Foot />
    </div>
</template>

<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
    data() {
        return {
            userinfo: {},
            Name: "",
            token: sessionStorage.getItem("token"),
            formLabelWidth: "100",
            dialogFormVisible: false,
            form: {
                password: "",
                password1: "",
                password2: "",
                type: 2,
            },
        };
    },
    created() {
        // console.log(sessionStorage.getItem("token"));
        this.getuserinfo();
    },
    methods: {
        getuserinfo() {
            this.$axios.post("welcome/info?token=" + this.token).then((res) => {
                console.log(res);
                if (res.data.code == 10000) {
                    this.userinfo = res.data.data;
                } else {
                    this.$message(res.data.msg);
                }
            });
        },
        changpswd() {
            let that = this;
            for (var key in this.form) {
                if (!this.form[key]) {
                    this.$message({
                        message: "信息填写不完整,请重新输入",
                        type: "warning",
                    });
                    return;
                }
            }
            const regex = /^.*(?=.{8,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%_^&*.?\\(\\)])(?!.*?[^\S*]).*$/;

            if (!regex.test(this.form.password1)) {
                this.$message({
                    message: "密码要求：长度为8-16个字符，必须包含大小写字母、数字、特殊符号（!@#$%_^&*.?不包括空格）",
                    type: "warning",
                });
                return;
            }
            if (this.form.password1 != this.form.password2) {
                this.$message({
                    message: "两次输入密码不一致",
                    type: "warning",
                });
                return;
            }
            that.$axios
                .post("welcome/setpwd?token=" + sessionStorage.getItem("token"), that.$qs.stringify(that.form))
                .then((res) => {
                    if (res.data.code == 10000) {
                        that.$message({ message: "修改成功", type: "success" });
                        that.dialogFormVisible = false;
                        that.$axios.post("login/logout?token=" + sessionStorage.getItem("token")).then((res) => {
                            if (res.data.code == 10000) {
                                sessionStorage.clear();
                                that.$message(res.data.msg);
                                that.$router.replace("/");
                                location.reload();

                                // that.isLogin=true
                            } else {
                                that.$message(res.data.msg);
                            }
                        });
                        //   location.reload()
                        //   for(var key in that.form){
                        //       console.log(that.form[key])
                        //   }
                    } else {
                        that.$message(res.data.msg);
                    }
                });
        },
    },
    components: {
        Head,
        Foot,
        Nav,
    },
};
</script>

<style lang="less" scoped>
.clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
.hotspot {
    width: 100%;
    min-width: 1000px;
    font-size: 0.16rem;
    padding: 0.28rem 2.54rem;
    box-sizing: border-box;
    .H-right {
        position: relative;
        width: 11.5rem;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        min-height: 8rem;
        border-left: 1px #eeeeee solid;
        main {
            width: 100%;
            margin-left: 0.3rem;
            padding: 0 2rem 0 0.5rem;

            .title {
                display: flex;
                justify-content: space-between;

                .btn {
                    font-size: 0.18rem;
                    cursor: pointer;
                    width: 0.94rem;
                    height: 0.34rem;
                    background: #2d65d2;
                    border-radius: 0.04rem;
                    color: white;
                    display: flex;
                    justify-content: center;
                }
                > div {
                    display: flex;
                    align-items: center;
                    i {
                        display: inline-block;
                        width: 0.3rem;
                        height: 0.3rem;
                        background-image: url("../../assets/Declare/geren1.png");
                        background-repeat: no-repeat;
                        background-size: 100%;
                        margin-right: 0.1rem;
                    }
                }
            }
            .container {
                margin-top: 0.5rem;
                div {
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 0.01rem solid #d9d9d9;
                    line-height: 0.8rem;
                    b {
                        color: #505050;
                        font-size: 0.18rem;
                    }
                    span {
                        display: inline-block;
                        width: 0.25rem;
                    }
                    p {
                        width: 70%;
                        color: #181818;
                        font-size: 0.2rem;
                    }
                }
                div.last {
                    width: 60%;
                    border-bottom: 0;
                    height: 100%;
                    img {
                        cursor: pointer;
                        margin-top: 0.2rem;
                        margin-bottom: 0.2rem;
                        max-width: 50%;
                        max-height: 2rem;
                    }
                }
            }
        }
    }
}
</style>
